<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24">
    <path :d="cartIconPath" />
  </svg>
</template>

<script setup lang="ts">
  import { cartIconPath } from '@/utils/cartIconPath';
</script>
